<template>
    <ul class="list-group list-group-flush">
        <li v-for="item, i in items" :key="i" class="list-group-item px-0 border-0">
            <div class="row align-items-start g-2">
                <div class="col-auto">
                    <i class="bi fs-4 bullet-icon" :class="getBulletStyle()"></i>
                </div>
                <div class="col">
                    <span v-if="item.subtitle" class="fw-bold">{{ item.subtitle }}</span>
                    {{ item.text }}
                </div>
            </div>
        </li>
    </ul>
</template>

<script setup lang="ts">
import { BulletListItem, BulletListIconStyle } from '@/guiide/ts/components/bulletListIconStyle';

const props = defineProps({
    items: { type: Array<BulletListItem>, required: true },
    iconStyle: { default: BulletListIconStyle.Bullet, required: false },
    showDivider: { default: true, required: false }
})

function getBulletStyle(): string {
    switch (props.iconStyle) {
        case BulletListIconStyle.Bullet:
            return "bullet-disc";
        case BulletListIconStyle.Tick:
            return "bi-check text-success";
        case BulletListIconStyle.Cross:
            return "bi-x text-danger";
        default:
            return "bullet-disc";
    }
}

</script>

<style scoped>
.bullet-disc {
  font-family: inherit !important;
}

.bullet-disc::before {
  content: "•";
  color: currentColor;
  font-weight: bold;
  font-size: 1.5em;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -63%);
}

.bullet-disc {
  position: relative;
  width: 1em;
  height: 1em;
  display: inline-block;
  font-style: normal !important;
}
</style>